import axios from "axios";

export default {
  namespaced: true,
  state: {
    file: null,
    customerprofiles: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    filesMessage: ''
  },
  mutations: {
    RECEIVED_FILES(state, payload) {
      state.customerprofiles = payload;
      state.isReceiving = false;
    },
    RECEIVED_FILE(state, payload) {
      state.file = payload;
    },
    RECEIVING_FILES(state) {
      state.isReceiving = true;
    },
    RECEIVING_FILE(state) {
      state.isReceiving = true;
    },
    UPDATED_FILE(state, payload) {
      let index = state.customerprofiles.findIndex(file => file._id === payload._id);
      state = Object.assign(state, {
        customerprofiles: state.customerprofiles.map((file, i) => {
          if (i === index) {
            return Object.assign({}, file, payload);
          }
          return file;
        }),
        isUpdating: false,
        filesMessage: 'Profiles has been updating!',
      })
    },
    UPDATING_FILE(state) {
      state.isUpdating = true;
    },
    DELETED_FILE(state, payload) {
      let indexToDelete = state.customerprofiles.findIndex(file => file._id === payload._id);
      let customerprofiles = [...state.customerprofiles];
      customerprofiles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        customerprofiles: [...customerprofiles],
        isDeleting: false,
        idToDelete: null,
        filesMessage: 'File has been Deleted!',
      });
    },
    DELETING_FILE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getCustomerProfiles({dispatch}, id) {
      dispatch("receivingProfiles");
      console.log(id)
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/customerprofiles/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receivedProfiles", response.data);
      return response.data;
    },
    async insertEmployeeFile({dispatch}, payload) {
      try{
        dispatch("receivingProfiles");
        console.log("HERE", payload);
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/employee/' + payload.employeeid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertPurchaseOrderFile({dispatch}, payload) {
      try{
        dispatch("receivingProfiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/purchaseorder/' + payload.purchaseorderid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertSalesOrderFile({dispatch}, payload) {
      try{
        dispatch("receivingProfiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/salesorder/' + payload.salesorderid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async deleteFileRequest({dispatch}, payload) {
      try{
        dispatch("updatingFile");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/file/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getDownloadFile({dispatch}, url){
      dispatch("updatingFile");
      const response = await fetch(url);
      let data = await response.blob();
      let blob = new Blob([data], { type: 'application/pdf' });
      let filesrc = URL.createObjectURL(blob);
      return filesrc;
    },
    receivedProfiles({commit}, payload) {
      commit("RECEIVED_FILES", payload)
    },
    receivingProfiles({commit}) {
      commit("RECEIVING_FILES")
    },
    receiveFile({commit}, payload) {
      commit("RECEIVED_FILE", payload)
    },
    receivingFile({commit}) {
      commit("RECEIVING_FILE")
    },
    updateFile({commit}, payload) {
      commit("UPDATED_FILE", payload)
    },
    updatingFile({commit}) {
      commit("UPDATING_FILE")
    },
    deleteFile({commit}, payload) {
      commit("DELETED_FILE", payload)
    },
    deletingFile({commit}, payload) {
      commit("DELETING_FILE", payload)
    }
  },
};
